module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1050"
    },
    model: {
      value: (_vm.dialogUploadLiveClass),
      callback: function($$v) {
        _vm.dialogUploadLiveClass = $$v
      },
      expression: "dialogUploadLiveClass"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    },
    scopedSlots: _vm._u([{
      key: "extension",
      fn: function() {
        return [_c('v-tabs', {
          attrs: {
            "grow": "",
            "color": "blew"
          },
          model: {
            value: (_vm.tabs),
            callback: function($$v) {
              _vm.tabs = $$v
            },
            expression: "tabs"
          }
        }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', {
          staticClass: "tab--text",
          attrs: {
            "href": "#tabs-1"
          },
          on: {
            "click": function($event) {
              return _vm.getImageUpload()
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("mdi-image-multiple")]), _vm._v(" "), _c('span', {
          staticClass: "ml-3"
        }, [_vm._v("List Gambar")])], 1), _vm._v(" "), _c('v-tab', {
          staticClass: "tab--text",
          attrs: {
            "href": "#tabs-2"
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("mdi-file-excel")]), _vm._v(" "), _c('span', {
          staticClass: "ml-3"
        }, [_vm._v("Upload Excel")])], 1)], 1)]
      },
      proxy: true
    }])
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-500"
  }, [_vm._v("Upload Live Class")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "800px"
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "tabs-1"
    }
  }, [
    [_c('transition', {
      attrs: {
        "name": "carousel"
      }
    }, [(_vm.page_upload === 'list') ? _c('div', [_c('div', {
      staticClass: "px-2 pt-10 pb-7"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "placeholder": "Cari Gambar",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.search),
        callback: function($$v) {
          _vm.search = $$v
        },
        expression: "search"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "d-flex align-center",
      staticStyle: {
        "gap": "15px"
      },
      attrs: {
        "cols": "3"
      }
    }, [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.toggle_exclusive),
        callback: function($$v) {
          _vm.toggle_exclusive = $$v
        },
        expression: "toggle_exclusive"
      }
    }, [_c('v-btn', {
      on: {
        "click": function($event) {
          _vm.mode_view = 'image'
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-image-outline")])], 1), _vm._v(" "), _c('v-btn', {
      on: {
        "click": function($event) {
          _vm.mode_view = 'list'
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-view-list-outline")])], 1)], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "success",
        "depressed": "",
        "dark": "",
        "large": ""
      },
      on: {
        "click": function($event) {
          _vm.page_upload = 'add'
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v("mdi-plus")]), _vm._v("\n                                                Upload\n                                            ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "px-2",
      attrs: {
        "hidden": _vm.mode_view === 'image'
      }
    }, [
      [_c('v-data-table', {
        attrs: {
          "headers": _vm.headers,
          "items": _vm.thumbnails,
          "search": _vm.search,
          "loading": _vm.isLoadingImage,
          "loading-text": "Mengambil data gambar..",
          "no-data-text": "Gambar tidak tersedia",
          "no-results-text": "Gambar tidak ditemukan",
          "footer-props": {
            'items-per-page-options': [
              10, 25 ],
          }
        },
        scopedSlots: _vm._u([{
          key: "item.action",
          fn: function(ref) {
            var item = ref.item;

            return [_c('v-btn', {
              staticClass: "white--text",
              attrs: {
                "depressed": "",
                "small": "",
                "color": "blew"
              },
              on: {
                "click": function($event) {
                  return _vm.copyUrl(item.url)
                }
              }
            }, [_vm._v("\n                                                    Copy\n                                                ")]), _vm._v(" "), _c('v-btn', {
              staticClass: "white--text ml-1",
              attrs: {
                "depressed": "",
                "small": "",
                "color": "primary"
              },
              on: {
                "click": function($event) {
                  return _vm.openUrl(item.url)
                }
              }
            }, [_vm._v("\n                                                    Open\n                                                ")])]
          }
        }], null, false, 1166675174)
      })]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "mt-7",
      attrs: {
        "hidden": _vm.mode_view === 'list'
      }
    }, [_c('v-row', {
      staticClass: "px-1"
    }, _vm._l((_vm.img_upload), function(file, index) {
      return _c('v-col', {
        key: index,
        staticClass: "pb-8",
        attrs: {
          "sm": "3",
          "cols": "3"
        }
      }, [_c('v-card', {
        staticClass: "mx-auto mb-6 fullheight",
        attrs: {
          "outlined": "",
          "max-width": "400"
        }
      }, [_c('v-img', {
        staticClass: "img-fluid",
        attrs: {
          "src": file.url,
          "title": 'file' + index,
          "height": "150px"
        }
      }), _vm._v(" "), _c('v-card-text', [_c('div', {
        staticClass: "font-weight-bold pb-3"
      }, [_vm._v("\n                                                        " + _vm._s(file.name) + "\n                                                    ")])]), _vm._v(" "), _c('v-card-actions', {
        staticStyle: {
          "position": "absolute",
          "bottom": "0",
          "width": "100%"
        }
      }, [_c('v-btn', {
        staticClass: "white--text",
        attrs: {
          "depressed": "",
          "small": "",
          "block": "",
          "color": "blew"
        },
        on: {
          "click": function($event) {
            return _vm.copyUrl(
              file.url
            )
          }
        }
      }, [_vm._v("\n                                                        Copy URL\n                                                    ")])], 1)], 1)], 1)
    }), 1)], 1)]) : _vm._e()])], _vm._v(" "), [_c('transition', {
      attrs: {
        "name": "carousel"
      }
    }, [(_vm.page_upload === 'add') ? _c('div', [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "px-2"
    }, [_c('div', {
      staticClass: "mt-5 mb-4"
    }, [_c('v-btn', {
      attrs: {
        "color": "#ec675e",
        "depressed": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          ((_vm.page_upload = 'list'),
            _vm.getImageUpload())
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v("mdi-arrow-left")]), _vm._v("\n                                                Kembali\n                                            ")], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "font-weight-bold pb-2 mt-5 mb-1 d-flex align-center",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v("\n                                            " + _vm._s(!_vm.file_images.length ?
      "Pilih Gambar *" :
      "List Gambar") + "\n\n                                            "), (!_vm.file_images.length) ? _c('v-menu', {
      attrs: {
        "close-on-content-click": false,
        "nudge-width": 200,
        "nudge-bottom": 10,
        "offset-y": "500"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "ml-1",
            attrs: {
              "color": "#474958",
              "dark": "",
              "icon": "",
              "small": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi\n                                                            mdi-information")])], 1)]
        }
      }], null, false, 4170179912),
      model: {
        value: (_vm.menu),
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    }, [_vm._v(" "), _c('v-card', {
      attrs: {
        "rounded": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-3"
    }, [_c('div', {
      staticClass: "font-weight-600 mb-2"
    }, [_vm._v("\n                                                            Petunjuk\n                                                        ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n                                                                Maksimum\n                                                                ukuran file\n                                                                300 KB\n                                                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                                                File gambar\n                                                                yang\n                                                                diizinkan :\n                                                                png, jpg,\n                                                                jpeg\n                                                            ")])])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "10"
      }
    }, [(
      !_vm.file_images.length
    ) ? _c('div', {
      staticClass: "wrapper-custom-input mt-2"
    }, [_c('v-card', {
      staticStyle: {
        "border": "2px"
      },
      attrs: {
        "outlined": "",
        "color": "#f7f8fa"
      }
    }, [_c('v-card-text', {
      staticClass: "py-6"
    }, [_c('div', {
      staticClass: "d-flex align-center",
      staticStyle: {
        "gap": "10px",
        "justify-content": "center"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#999999",
        "large": ""
      }
    }, [_vm._v("\n                                                                    mdi\n                                                                    mdi-cloud-upload\n                                                                ")]), _vm._v(" "), _c('span', {
      staticClass: "ml-3"
    }, [_c('p', [_vm._v("\n                                                                        Tarik\n                                                                        dan\n                                                                        letakkan\n                                                                        atau\n                                                                        "), _c('b', {
      staticClass: "text-primary"
    }, [_vm._v("Pilih\n                                                                            Gambar")]), _vm._v("\n                                                                        untuk\n                                                                        unggah\n                                                                        gambar\n                                                                        live\n                                                                        class\n                                                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                                        Pastikan\n                                                                        sesuai\n                                                                        format\n                                                                        png,\n                                                                        jpg,\n                                                                        jpeg\n                                                                        yang\n                                                                        disediakan\n                                                                        dengan\n                                                                        maksimal\n                                                                        ukuran\n                                                                        300kb.\n                                                                    ")])])], 1)])], 1), _vm._v(" "), _c('input', {
      staticClass: "custom-file-input",
      attrs: {
        "type": "file",
        "multiple": "",
        "accept": "image/svg, image/jpg, image/png, image/jpeg"
      },
      on: {
        "change": _vm.addFilesImages
      }
    })], 1) : _vm._e(), _vm._v(" "), (
      _vm.file_images.length
    ) ? _c('div', [_c('div', {
      staticClass: "content-display pt-5"
    }, [_c('v-row', {
      staticClass: "px-1"
    }, _vm._l((_vm.file_images), function(file, f) {
      return _c('v-col', {
        key: f,
        attrs: {
          "sm": "4",
          "cols": "4"
        }
      }, [_c('v-card', {
        staticClass: "mx-auto mb-6",
        attrs: {
          "max-width": "400",
          "outlined": ""
        }
      }, [_c('v-img', {
        staticClass: "img-fluid",
        attrs: {
          "src": _vm.imageSources[
            f
          ],
          "title": file.name,
          "height": "150px"
        }
      }), _vm._v(" "), _c('v-card-text', {
        staticClass: "text--primary px-3"
      }, [_c('div', {
        staticStyle: {
          "min-height": "50px"
        }
      }, [_vm._v("\n                                                                            " + _vm._s(file.name) + "\n                                                                            "), _c('v-btn', {
        staticClass: "ml-1",
        attrs: {
          "rounded": "",
          "depressed": "",
          "small": ""
        }
      }, [_vm._v("\n                                                                                " + _vm._s((
        file.size /
        1000
      ).toFixed(
        1
      )) + "\n                                                                                KB\n                                                                            ")])], 1), _vm._v(" "), _c('v-btn', {
        staticClass: "mt-5",
        attrs: {
          "outlined": "",
          "color": "red",
          "block": ""
        },
        on: {
          "click": function($event) {
            return _vm.removeImage(
              f
            )
          }
        }
      }, [_c('v-icon', {
        staticClass: "mr-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                                                                mdi-delete\n                                                                            ")]), _vm._v("\n                                                                            Hapus\n                                                                        ")], 1)], 1)], 1)], 1)
    }), 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "2"
      }
    }, [_c('v-btn', {
      staticClass: "white--text mt-2",
      attrs: {
        "depressed": "",
        "large": "",
        "block": "",
        "color": "#27ae60",
        "disabled": !_vm.file_images.length,
        "loading": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.uploadImage()
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v("mdi-plus")]), _vm._v("\n                                                    Upload\n                                                ")], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()])]
  ], 2), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tabs-2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-2"
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2 mt-5"
  }, [_vm._v("\n                                        Pilih File Excel *\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-file-input', {
    attrs: {
      "outlined": "",
      "x-large": "",
      "dense": "",
      "prepend-icon": "mdi-file-excel",
      "show-size": "",
      "counter": "",
      "small-chips": "",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: (_vm.file_excel),
      callback: function($$v) {
        _vm.file_excel = $$v
      },
      expression: "file_excel"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-3 py-5 white--text",
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "depressed": "",
      "color": "#1f9b60",
      "disabled": !_vm.file_excel,
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.convertToJson()
      }
    }
  }, [_vm._v("\n                                            Upload\n                                        ")])], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "depressed": "",
      "small": "",
      "color": "#1f9b60"
    },
    on: {
      "click": function($event) {
        return _vm.downloadExcel()
      }
    }
  }, [_vm._v("\n                                            Download Template\n                                        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blew--text ml-1",
    attrs: {
      "depressed": "",
      "small": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        _vm.show_code = !_vm.show_code
      }
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.show_code ? "Tutup" : "Buka") + "\n                                            Petunjuk\n                                        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-10 mx-5",
    attrs: {
      "hidden": !_vm.show_code
    }
  }, [_c('div', {
    staticClass: "mb-8"
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "#f0f0f0"
    }
  }, [_c('v-card-text', {
    staticClass: "px-3 pt-3 pb-1"
  }, [_c('div', {
    staticClass: "mb-2 font-weight-600"
  }, [_vm._v("\n                                                Pilih File Excel*\n                                            ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n                                                    Pastikan value yang\n                                                    diisi di dalam template\n                                                    sesuai dengan filenya\n                                                ")]), _vm._v(" "), _c('li', [_vm._v("\n                                                    Masukkan sesuai contoh\n                                                ")]), _vm._v(" "), _c('li', [_vm._v("\n                                                    Nilai id yang dibutuhkan\n                                                    bisa dilihat\n                                                ")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [
    [_c('v-simple-table', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left",
            attrs: {
              "width": "25%"
            }
          }, [_vm._v("\n                                                                Kode Guru\n                                                            ")]), _vm._v(" "), _c('th', {
            staticClass: "text-left"
          }, [_vm._v("\n                                                                Nama Guru\n                                                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.teachers), function(item, i) {
            return _c('tr', {
              key: i
            }, [_c('td', {
              staticClass: "font-weight-bold"
            }, [_vm._v("\n                                                                " + _vm._s(item.id) + "\n                                                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                                                " + _vm._s(item.teacher_name) + "\n                                                            ")])])
          }), 0)]
        },
        proxy: true
      }])
    })]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [
    [_c('v-simple-table', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left",
            attrs: {
              "width": "25%"
            }
          }, [_vm._v("\n                                                                Kode Mapel\n                                                            ")]), _vm._v(" "), _c('th', {
            staticClass: "text-left"
          }, [_vm._v("\n                                                                Nama Mapel\n                                                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.mapels), function(item, i) {
            return _c('tr', {
              key: i
            }, [_c('td', {
              staticClass: "font-weight-bold"
            }, [_vm._v("\n                                                                " + _vm._s(item.id) + "\n                                                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                                                " + _vm._s(item.nama) + "\n                                                            ")])])
          }), 0)]
        },
        proxy: true
      }])
    })]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [
    [_c('v-simple-table', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left",
            attrs: {
              "width": "30%"
            }
          }, [_vm._v("\n                                                                Kode User\n                                                                Group\n                                                            ")]), _vm._v(" "), _c('th', {
            staticClass: "text-left"
          }, [_vm._v("\n                                                                Nama User\n                                                                Group\n                                                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.user_groups), function(item, i) {
            return _c('tr', {
              key: i
            }, [_c('td', {
              staticClass: "font-weight-bold"
            }, [_vm._v("\n                                                                " + _vm._s(item.id) + "\n                                                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                                                " + _vm._s(item.user_group_name) + "\n                                                            ")])])
          }), 0)]
        },
        proxy: true
      }])
    })]
  ], 2)])])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "blew",
      "top": "",
      "timeout": "1500"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', attrs, false), [_vm._v("\n                Tutup\n            ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbar_text) + "\n\n        ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e878e3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/Upload.vue
// module id = 1669
// module chunks = 1